import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import Spinner from '@/components/common/Spinner';
import { SectionScrollModelProvider } from '@/components/common/context/SectionScrollModelProvider';
import Layout from '@/components/layout/Layout';
import { PhoneNumberContent } from '@/components/tax-refund/phone-number/PhoneNumberContent';

function RefundPhoneNumberPage() {
  const router = useRouter();

  const businessType = router.query?.type as 'indis' | 'corps' | undefined;

  if (!businessType) {
    return <Spinner />;
  }

  return (
    <PageViewEventLogger
      pageName={businessType === 'corps' ? 'corps-request' : 'indis-request'}
      eventName={businessType === 'corps' ? 'corps-request_phonenumber' : 'indis-request_phonenumber'}
    >
      <Layout leftIcon={{ icon: 'back', clickEvent: { name: `${businessType === 'corps' ? 'corps-request' : 'indis-request'}_topnav_back` } }}>
        <PhoneNumberContent businessType={businessType} />
      </Layout>
    </PageViewEventLogger>
  );
}

RefundPhoneNumberPage.getLayout = (page: ReactElement) => (
  <AuthGuard>
    <SectionScrollModelProvider>{page}</SectionScrollModelProvider>
  </AuthGuard>
);

export default RefundPhoneNumberPage;
